import React from "react";
import "../../Styles/yellowcalf.css/Pending_Invoices_Invoice.css";

function Pending_Invoices_Invoice() {
  return (
    <div
      className="pending-invoices-invoice-container"
      style={{ paddingTop: "25px" }}
    >
      <div className="pending-invoices-invoice-row">
        <div className="pending-invoices-invoice-col">
          <div className="pending-invoices-invoice-panel">
            <div className="pending-invoices-invoice-panel-body">
              <h3 className="pending-invoices-invoice-title">Invoice</h3>
              <p className="pending-invoices-invoice-description"></p>
            </div>
          </div>
        </div>
      </div>

      <div className="pending-invoices-invoice-alert">
        No Payment Gateway found. Please enable payment gateway
      </div>
    </div>
  );
}

export default Pending_Invoices_Invoice;
